// extracted by mini-css-extract-plugin
export default {"grid1":"fs_grid1__B525o","previewCard":"fs_previewCard__p+8jO","labelc1":"fs_labelc1__pezcO","previewHead":"fs_previewHead__YTgr1"};